import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import axios from "../../config/axios";
import Loading from "components/Loading";
import { isEmpty } from "lodash";
import { useSnackbar } from "notistack";
import { Button, makeStyles } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Add, Edit as EditIcon } from "@material-ui/icons";
import { CarrierAddOrEdit } from "./CarrierAddOrEdit";
import IconButton from "@material-ui/core/IconButton";

import "./index.css";
import DeleteConfirmation from "components/DeleteConfirmation";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    flexGrow: 1
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 750
  },
  loading: {
    display: "flex",
    justifyContent: "center"
  }
}));

const CarrierList = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [carriers, setCarriers] = useState([]);
  const [editCarrier, setEditCarrier] = useState(null);
  const [fetchingCarriers, setFetchingCarriers] = useState(false);
  const [isOpenCarrierPopup, setIsOpenCarrierPopup] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const fetchCarriers = useCallback(() => {
    setFetchingCarriers(true);
    axios
      .get(`/admin/carriers`)
      .then(res => {
        setFetchingCarriers(false);
        setCarriers(res.data.data.carriers);
      })
      .catch(error => {
        enqueueSnackbar(error, { variant: "error" });
      });
  }, [enqueueSnackbar]);

  useEffect(() => {
    if (isEmpty(carriers)) {
      fetchCarriers();
    }
  }, [carriers, fetchCarriers]);

  const onClickAddNewCarrier = () => {
    setIsOpenCarrierPopup(true);
  };
  const handleCloseCarrierPopup = () => {
    setIsOpenCarrierPopup(false);
    setEditCarrier(null);
    fetchCarriers();
  };

  const handlDeleteCarrier = carrierId => {
    axios.delete(`/admin/remove-carrier/${carrierId}`).then(() => {
      enqueueSnackbar(t("carriers.carrierRemoved"), { variant: "success" });
      fetchCarriers();
    });
  };

  const handleEditCarrier = carrier => {
    setIsOpenCarrierPopup(true);
    setEditCarrier(carrier);
  };

  return (
    <div className="carrier-list">
      <CarrierAddOrEdit isOpen={isOpenCarrierPopup} handleClose={handleCloseCarrierPopup} editCarrier={editCarrier} />
      {fetchingCarriers && isEmpty(carriers) ? (
        <div className={classes.loading}>
          <Loading />
        </div>
      ) : (
        <div>
          {carriers && carriers.length > 0 && (
            <div>
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                <Button startIcon={<Add />} color="primary" variant="contained" onClick={() => onClickAddNewCarrier()}>
                  {t("carriers.addNewCarrier")}
                </Button>
              </div>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("carriers.carrierId")}</TableCell>
                      <TableCell>{t("carriers.name")}</TableCell>
                      <TableCell>{t("carriers.email")}</TableCell>
                      <TableCell>{t("carriers.areaName")}</TableCell>
                      <TableCell>{t("carriers.latitude")}</TableCell>
                      <TableCell>{t("carriers.longitude")}</TableCell>
                      <TableCell>{t("carriers.active")}</TableCell>
                      <TableCell>{t("carriers.actions")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {carriers.map(carrier => (
                      <TableRow key={carrier._id}>
                        <TableCell> {carrier._id}</TableCell>
                        <TableCell>{carrier.name}</TableCell>
                        <TableCell>{carrier.email}</TableCell>
                        <TableCell>{carrier.area_name}</TableCell>
                        <TableCell>{carrier.latitude}</TableCell>
                        <TableCell>{carrier.longitude}</TableCell>
                        <TableCell>{carrier.is_active ? "Yes" : "No"}</TableCell>
                        <TableCell>
                          <div style={{ display: "flex" }}>
                            <IconButton aria-label="expand row" size="small" onClick={() => handleEditCarrier(carrier)}>
                              <EditIcon />
                            </IconButton>
                            <DeleteConfirmation onConfirm={handlDeleteCarrier} data={carrier._id} />
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CarrierList;
